import { 
  Badge, 
  Box, 
  Button, 
  IconButton, 
  useMediaQuery, 
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  AppBar,
  Toolbar,
  Slide,
  useScrollTrigger
} from "@mui/material";
import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { useNavigate } from "react-router-dom";
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import GetAppIcon from '@mui/icons-material/GetApp';
import { Base64 } from 'js-base64';
import Network from "./network/Network";
import instId from "./network/instituteId";

// Hide on scroll component
function HideOnScroll(props) {
  const { children } = props;
  const trigger = useScrollTrigger({
    threshold: 100,
  });

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}

export const Navigation = forwardRef((props, ref) => {

  const isMobileDevice = useMediaQuery('(max-width:768px)');
  const isTablet = useMediaQuery('(max-width:1024px)');
  let cartData = localStorage.getItem('cartArray');
  const navigate = useNavigate();
  const [cartItem, setCartItem] = useState([]);
  const [refresh, setrefresh] = useState(false);
  const [coursesList, setCoursesList] = useState([]);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    getAllCourses();
  }, []);

  const getAllCourses = async () => {
    const response = await Network.fetchCourses(instId);
    const course = response?.courses;
    const filterCourses = course?.filter((item) => item?.active === true);
    setCoursesList(filterCourses);
  };

  const handleLogoClick = () => {
    navigate('/');

  };

  useImperativeHandle(ref, () => ({
    update() {
      handleCartCount()
    }

  }));

  const handleCartCount = () => {
    setrefresh(!refresh)
  }
  useEffect(() => {
    if (cartData !== null && cartData !== undefined) {
      setCartItem(cartData ? JSON.parse(cartData) : [])
    }
  }, [cartData, refresh])

  const handleCartClick = () => {
    let courseItem = localStorage.getItem('selectCourse');
    let data = Base64.encode(JSON.stringify({ courseObj: JSON.parse(courseItem) }), true)
    navigate('/test-series?data=' + data, { state: { cartRoute: "cartRoute" } })
  }

  const handleCaInterCourse = (item) => {
    const value = coursesList.find(course => course.title === item);
    if (value) {
      navigate('/course-content', { state: { data: value } });
    } else {
      console.error("Course not found");
    }
  }

  const handleAboutUs = () => {
    navigate('/aboutUs');
  }

  const handleFreeResources = () => {
    navigate('/free-resouces');
  }

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const menuItems = [
    { title: 'About us', onClick: handleAboutUs },
    { title: 'Our Test Series Team', href: '#whyfast' },
    { title: 'CA Foundation Test Series', onClick: () => handleCaInterCourse("CA Foundation") },
    { title: 'CA Inter Test Series', onClick: () => handleCaInterCourse("CA Inter") },
    { title: 'CA Final Test Series', onClick: () => handleCaInterCourse("CA Final") },
    { title: 'Free Resources', onClick: handleFreeResources },
  ];

  const MobileDrawer = () => (
    <Drawer
      variant="temporary"
      anchor="right"
      open={mobileOpen}
      onClose={handleDrawerToggle}
      ModalProps={{
        keepMounted: true,
      }}
      sx={{
        '& .MuiDrawer-paper': {
          width: 280,
          background: 'linear-gradient(145deg, #1354C1 0%, #0d47a1 100%)',
          color: '#fff',
        },
      }}
    >
      <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <img 
          src="img/Image [header-logo].png" 
          alt="Logo" 
          style={{ width: "100px", cursor: 'pointer' }} 
          onClick={() => {
            handleLogoClick();
            handleDrawerToggle();
          }}
        />
        <IconButton onClick={handleDrawerToggle} sx={{ color: '#fff' }}>
          <CloseIcon />
        </IconButton>
      </Box>
      <List sx={{ pt: 0 }}>
        {menuItems.map((item, index) => (
          <ListItem key={index} disablePadding>
            <ListItemButton
              onClick={() => {
                if (item.onClick) item.onClick();
                if (item.href) {
                  document.querySelector(item.href)?.scrollIntoView({ behavior: 'smooth' });
                }
                handleDrawerToggle();
              }}
              sx={{
                py: 2,
                px: 3,
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                },
              }}
            >
              <ListItemText 
                primary={item.title} 
                sx={{ 
                  '& .MuiTypography-root': { 
                    fontWeight: 500,
                    fontSize: '16px'
                  } 
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
        <ListItem sx={{ px: 3, py: 2 }}>
          <Button
            fullWidth
            variant="contained"
            startIcon={<GetAppIcon />}
            sx={{
              background: 'linear-gradient(45deg, #fff 0%, #f5f5f5 100%)',
              color: '#1354C1',
              fontWeight: 'bold',
              borderRadius: '25px',
              textTransform: 'none',
              py: 1.5,
              '&:hover': {
                background: 'linear-gradient(45deg, #f5f5f5 0%, #e0e0e0 100%)',
              }
            }}
          >
            Download our App
          </Button>
        </ListItem>
        {cartItem?.length > 0 && (
          <ListItem sx={{ px: 3 }}>
            <Button
              fullWidth
              variant="outlined"
              startIcon={
                <Badge badgeContent={cartItem.length} color="error">
                  <AddShoppingCartIcon />
                </Badge>
              }
              onClick={() => {
                handleCartClick();
                handleDrawerToggle();
              }}
              sx={{
                borderColor: '#fff',
                color: '#fff',
                borderRadius: '25px',
                textTransform: 'none',
                py: 1.5,
                '&:hover': {
                  borderColor: '#fff',
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                }
              }}
            >
              View Cart
            </Button>
          </ListItem>
        )}
      </List>
    </Drawer>
  );


  return (
    <>
      <HideOnScroll>
        <AppBar 
          position="fixed" 
          sx={{
            background: 'linear-gradient(135deg, #1354C1 0%, #0d47a1 100%)',
            backdropFilter: 'blur(10px)',
            boxShadow: '0 8px 32px rgba(19, 84, 193, 0.3)',
            borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
          }}
        >
          <Toolbar sx={{ px: { xs: 2, md: 4 }, py: 1 }}>
            {/* Logo */}
            <Box sx={{ flexGrow: 0, display: 'flex', alignItems: 'center' }}>
              <img 
                src="img/Image [header-logo].png" 
                className="img-responsive logo-image" 
                alt="Logo" 
                style={{ 
                  width: isMobileDevice ? "110px" : "140px", 
                  cursor: 'pointer',
                  transition: 'transform 0.3s ease',
                }} 
                onClick={handleLogoClick}
                onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
                onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
              />
            </Box>

            {/* Desktop Navigation */}
            {!isMobileDevice && (
              <Box sx={{ 
                flexGrow: 1, 
                display: 'flex', 
                justifyContent: 'center',
                ml: 4
              }}>
                <Box sx={{ 
                  display: 'flex', 
                  gap: isTablet ? 2 : 3,
                  alignItems: 'center',
                  flexWrap: 'wrap'
                }}>
                  {menuItems.map((item, index) => (
                    <Button
                      key={index}
                      onClick={item.onClick || (() => {
                        if (item.href) {
                          document.querySelector(item.href)?.scrollIntoView({ behavior: 'smooth' });
                        }
                      })}
                      sx={{
                        color: '#fff',
                        fontWeight: 500,
                        fontSize: isTablet ? '13px' : '14px',
                        textTransform: 'none',
                        px: isTablet ? 1.5 : 2,
                        py: 1,
                        borderRadius: '20px',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          backgroundColor: 'rgba(255, 255, 255, 0.15)',
                          transform: 'translateY(-2px)',
                          boxShadow: '0 4px 12px rgba(255, 255, 255, 0.2)',
                        }
                      }}
                    >
                      {item.title}
                    </Button>
                  ))}
                </Box>
              </Box>
            )}

            {/* Right side actions */}
            <Box sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: 2,
              ml: 'auto'
            }}>
              {/* Desktop Download Button */}
              {!isMobileDevice && (
                <Button
                  variant="contained"
                  startIcon={<GetAppIcon />}
                  sx={{
                    background: 'linear-gradient(45deg, #fff 0%, #f5f5f5 100%)',
                    color: '#1354C1',
                    fontWeight: 'bold',
                    borderRadius: '25px',
                    textTransform: 'none',
                    px: 3,
                    py: 1,
                    fontSize: '13px',
                    boxShadow: '0 4px 12px rgba(255, 255, 255, 0.3)',
                    '&:hover': {
                      background: 'linear-gradient(45deg, #f5f5f5 0%, #e0e0e0 100%)',
                      transform: 'translateY(-2px)',
                      boxShadow: '0 6px 16px rgba(255, 255, 255, 0.4)',
                    }
                  }}
                >
                  Download App
                </Button>
              )}

              {/* Cart Icon */}
              {cartItem?.length > 0 && (
                <IconButton 
                  onClick={handleCartClick}
                  sx={{ 
                    color: '#fff',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      backgroundColor: 'rgba(255, 255, 255, 0.15)',
                      transform: 'scale(1.1)',
                    }
                  }}
                >
                  <Badge 
                    badgeContent={cartItem.length} 
                    color="error"
                    sx={{
                      '& .MuiBadge-badge': {
                        background: 'linear-gradient(45deg, #ff4444 0%, #cc0000 100%)',
                        fontWeight: 'bold',
                        fontSize: '12px',
                      }
                    }}
                  >
                    <AddShoppingCartIcon sx={{ fontSize: '28px' }} />
                  </Badge>
                </IconButton>
              )}

              {/* Mobile Menu Button */}
              {isMobileDevice && (
                <IconButton
                  onClick={handleDrawerToggle}
                  sx={{ 
                    color: '#fff',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      backgroundColor: 'rgba(255, 255, 255, 0.15)',
                      transform: 'rotate(90deg)',
                    }
                  }}
                >
                  <MenuIcon sx={{ fontSize: '28px' }} />
                </IconButton>
              )}
            </Box>
          </Toolbar>
        </AppBar>
      </HideOnScroll>

      {/* Mobile Drawer */}
      <MobileDrawer />

      {/* Spacer for fixed AppBar */}
      <Toolbar />
    </>
  );
});
